export const extractZipCodeFromGeosuggest = (suggestion) => {
	return extractFromGeoSuggest('postal_code', suggestion)
}

export const extractStreetNumberCodeFromGeosuggest = (suggestion) => {
	return extractFromGeoSuggest('street_number', suggestion)
}

export const extractFromGeoSuggest = (type, suggestion) => {
	if (suggestion !== undefined && suggestion.gmaps !== undefined && suggestion.gmaps.address_components !== undefined) {
		let addressComponents = suggestion.gmaps.address_components
		let component = addressComponents.find((component) => {
			return component.types.includes(type)
		})
		if (component !== undefined) {
			return component.long_name
		}
	}

	return undefined
}

const MINIMUM_RECOMMENDED_HOURS = 3
export const computeDuration = (roomsCount, servicesCount) => {
	let recommendedHours = ((roomsCount - 2.0) * 0.5) + 3.0
	recommendedHours += (servicesCount * 0.5)
	recommendedHours = Math.ceil(recommendedHours)

	return Math.max(recommendedHours, MINIMUM_RECOMMENDED_HOURS)
}


// WEBPACK FOOTER //
// ./src/helpers/bookingFlowHelpers.js